import { render } from "./App.vue.ts?vue&type=template&id=2dd71dfa&ts=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./App.vue?vue&type=template&id=2dd71dfa&ts=true"
import script from "./App.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./App.vue?vue&type=script&lang=ts"
export * from "./App.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./App.vue?vue&type=script&lang=ts"

import "./App.vue.scss?vue&type=style&index=0&id=2dd71dfa&lang=scss!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./App.vue?vue&type=style&index=0&id=2dd71dfa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__